import { render, staticRenderFns } from "./RateForm.vue?vue&type=template&id=7463e486&scoped=true"
import script from "./RateForm.vue?vue&type=script&lang=js"
export * from "./RateForm.vue?vue&type=script&lang=js"
import style0 from "./RateForm.vue?vue&type=style&index=0&id=7463e486&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463e486",
  null
  
)

export default component.exports